import type { FC } from 'react';
import { Box, Grid } from '@ltvco/refresh-lib/theme';
import { ArrowForward } from '@mui/icons-material';
import {
  StyledCard,
  Headline,
  BodyText,
  CtaButton,
  IllustrationGrid,
  IllustrationImage,
} from './components';

export interface ReportSectionCTACardProps {
  id: string;
  headline: string;
  bodyText: string;
  buttonText: string;
  onButtonClick: () => void;
  illustration: { src: string; alt: string };
  dataTestId?: string;
}

export const ReportSectionCTACard: FC<ReportSectionCTACardProps> = ({
  id,
  headline,
  bodyText,
  buttonText,
  onButtonClick,
  illustration,
  dataTestId,
}) => {
  return (
    <StyledCard id={id} variant="outlined" data-testid={dataTestId ?? id}>
      <Grid container>
        <Grid size={{ xs: 12, md: 6 }}>
          <Box sx={{ p: 3.5 }}>
            <Headline variant="h5">{headline}</Headline>
            <BodyText variant="body1">{bodyText}</BodyText>
            <CtaButton
              variant="contained"
              onClick={onButtonClick}
              endIcon={<ArrowForward />}
              data-testid={dataTestId ? `${dataTestId}-button` : undefined}
            >
              {buttonText}
            </CtaButton>
          </Box>
        </Grid>
        <IllustrationGrid size={{ xs: 12, md: 6 }}>
          <IllustrationImage src={illustration.src} alt={illustration.alt} />
        </IllustrationGrid>
      </Grid>
    </StyledCard>
  );
};
